import type { Action } from '../actions';
import type { UserConsentState } from './userConsent.model';

export function userConsentReducer(state: UserConsentState = {}, action: Action): UserConsentState {
  switch (action.type) {
    case 'VIDEO_USER_CONSENT_CHANGED':
      return { ...state, hasGivenConsentToVideo: action.consent };
    case 'MATOMO_USER_CONSENT_CHANGED':
      return { ...state, hasGivenConsentToMatomoUserTracking: action.consent };
    default:
      return state;
  }
}
